export default {
      id: "icon-logo-small-usage",
      viewBox: "0 0 36.13 31.23",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-logo-small",
      toString: function () {
        return this.url;
      }
    }